<template>
  <a-modal
    centered
    :maskClosable="false"
    title="添加折扣"
    v-model="visible"
    width="450px"
    @ok="onSubmit"
    @cancel="onCancel"
    :confirmLoading="confirmLoading"
  >
    <div class="form-item">
      <label>折扣：</label>
      <span>
        <a-input-number
          v-model="Discount"
          :min="0"
          :precision="2"
          @change="countAmount(1)"
        ></a-input-number>
        折
      </span>
    </div>
    <div class="form-item">
      <label>折后金额：</label>
      <span>
        <a-input-number
          :min="0"
          :precision="2"
          v-model="AmountAfterDiscount"
          @change="countAmount(2)"
        ></a-input-number>
      </span>
    </div>
  </a-modal>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      visible: false,
      Discount: "0",
      AmountAfterDiscount: 0,
      confirmLoading: false
    };
  },
  created() {},
  methods: {
    show(info) {
      this.visible = true;
      this.info = info;
      this.Discount = 0;
      this.AmountAfterDiscount = this.info.FinalAmount;
    },
    onCancel() {
      this.visible = false;
    },
    countAmount(type) {
      const { $post } = this;
      const json = {
        Id: this.info.Id,
        IsPreview: true
      };
      if (type == 1) {
        json.Discount = this.Discount ? this.Discount : 0;
      } else if (type == 2) {
        json.AmountAfterDiscount = this.AmountAfterDiscount;
      }
      $post("RMS_Discount", json).then(res => {
        if (type == 1) {
          this.AmountAfterDiscount = res.Data.FinalAmount;
        } else {
          this.Discount = res.Data.Discount;
        }
      });
    },
    onSubmit() {
      this.confirmLoading = true;
      setTimeout(() => {
        this.$post("RMS_Discount", {
          Id: this.info.Id,
          AmountAfterDiscount: this.AmountAfterDiscount,
          IsPreview: false
        })
          .then(res => {
            this.confirmLoading = false;
            this.$message.success("操作成功");
            this.$emit("submit", res.Data);
            this.visible = false;
          })
          .catch(() => {
            this.confirmLoading = false;
          });
      }, 150);
    }
  }
};
</script>

<style lang="less" scoped>
.form-item {
  display: flex;
  margin-top: 15px;
  margin-bottom: 15px;
  label {
    min-width: 100px;
    text-align: right;
  }
  .ant-input-number {
    width: 130px;
  }
}
</style>
